module.exports = __webpack_public_path__ + "static/media/loader.e76b5e49.svg";